import {
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Spinner,
  Alert,
  Label,
  FormGroup,
  Input,
} from "design-react-kit";
import { useState } from "react";

const ConfirmExternalFlowSendModal = ({
  confirmModalOpen,
  confirmModalCloseHandler,
  authorizeForSending,
  isLoading,
  error,
  flowId,
}) => {
  const [isAccepted, setIsAccepted] = useState(false);
  const [isConsent, setIsConsent] = useState(false);

  return (
    <Modal
      id="externalFlowConfirmModal"
      isOpen={confirmModalOpen}
      toggle={confirmModalCloseHandler}
      align="center"
      scrollable
      labelledBy="confirmExternalFlowSendModal"
    >
      <ModalHeader
        toggle={confirmModalCloseHandler}
        id="confirmExternalFlowSendModal"
      ></ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <Icon icon="it-info-circle" fill="#D70049" />
          <h5 className="d-inline font-weight-bold ml-2">ATTENZIONE</h5>
        </div>
        {error !== null && error.length !== undefined && (
          <Alert color="danger">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && <Spinner double active />}
        <p className="mb-2 font-weight-normal">
          Nel caso si stia procedendo alla trasmissione verso SEND di uno o più
          documenti in formato PDF <b>non firmato/i digitalmente</b> e
          necessario considerare quanto segue:
        </p>
        <ul>
          <li>
            Il requisito della forma scritta ex art. 2702 c.c. degli allegati è
            integrato, ai sensi del comma 1bis, dell'art. 20 C.A.D. (D.Lgs. 7
            marzo 2005, n. 82 e ss.mm.), dall'apposizione una{" "}
            <b>firma digitale</b>, ovvero altro tipo di firma elettronica
            qualificata o una firma elettronica avanzata o, comunque, dalla
            formazione del documento previa identificazione informatica del suo
            autore, attraverso un processo avente i requisiti fissati dall'AgID
            nelle Linee Guida emanate ai sensi dell'articolo 71 del C.A.D, con
            modalità tali da garantire la sicurezza, integrità e
            immodificabilità del documento e, in maniera manifesta e inequivoca,
            la sua riconducibilità all'autore.
          </li>
          <li>
            In caso di contestazioni da parte del destinatario della notifica di
            un documento non sottoscritto con le modalità individuate dall'art.
            20 C.A.D., il valore probatorio del documento è liberamente
            valutabile dal giudice ex art. 2702 c.c.
          </li>
          <li>
            L'art. 13 del D.M. 8 febbraio 2022, n. 58 dispone che i mittenti
            sono responsabili del contenuto degli atti notificati tramite la
            piattaforma, nonché delle informazioni fornite al gestore della
            stessa.
          </li>
        </ul>
        <p className="mb-2 font-weight-normal">
          Accettando di proseguire, l'amministrazione dichiara di essere stata
          resa edotta dei potenziali rischi in cui potrebbe incorrere
          proseguendo con l'invio di un documento non firmato digitalmente e
          dichiara di voler ugualmente effettuare l'invio, consapevole della
          responsabilità gravante sul mittente ex art. 13 D.M. 58/2022.
          L'amministrazione, inoltre, accettando di proseguire esonera, manleva
          e si impegna a tenere indenne Progetti e Soluzioni S.p.A. da ogni
          responsabilità derivante dalla trasmissione di tale documento.{" "}
        </p>
        <fieldset>
          <FormGroup check>
            <Input
              id="accept"
              type="checkbox"
              onClick={(e) => setIsAccepted(e.target.checked)}
            />
            <Label check for="accept">
              ACCETTO
            </Label>
          </FormGroup>
        </fieldset>
        <p className="mb-2 font-weight-normal">
          L'amministrazione, infine, dichiara di aver preso visione
          dell'informativa privacy presente a{" "}
          <a href="/Informativa_Privacy.pdf" target="_blank">
            {" "}
            questo link
          </a>{" "}
          e di essere a conoscenza dell'attività di tracciamento di data, ora ed
          identità dell'operatore che fornisce l'autorizzazione a proseguire di
          cui al punto precedente, nei termini e per le finalità di cui
          all'informativa.
        </p>
        <fieldset>
          <FormGroup check>
            <Input
              id="consent"
              type="checkbox"
              onClick={(e) => setIsConsent(e.target.checked)}
            />
            <Label check for="consent">
              HO LETTO E COMPRESO L'INFORMATIVA
            </Label>
          </FormGroup>
        </fieldset>
        <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-around">
          <Button
            color="white"
            className="mr-2"
            onClick={confirmModalCloseHandler}
            id="user-cancel"
          >
            Annulla
          </Button>
          <div style={{ width: "100px" }}>
            {isAccepted && isConsent && (
              <Button
                color="success"
                onClick={(e) => {
                  authorizeForSending(flowId);
                }}
              >
                Conferma
              </Button>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmExternalFlowSendModal;
